// extracted by mini-css-extract-plugin
export default {"wrapper":"EmbedMap_wrapper__t6kF9","map":"EmbedMap_map__WCP62"};